import React, { Component } from 'react';
import { connect } from 'react-redux';
import './menutoggler.css';
import iconmenublack from './icon-menu.svg';
import iconmenuwhite from './icon-menu-white.svg';

import { toggleMenuAction } from '../../actions/siteActions';

class Menutoggler extends Component {

    constructor(props) {
        super(props);
        this.toggleMenu = this.toggleMenu.bind(this);
    }

    componentWillUnmount() {
        this.props.dispatch(toggleMenuAction(false));
    }

    toggleMenu(e) {
        e.preventDefault();
        this.props.dispatch(toggleMenuAction());
    }

    render() {

        let iconmenu = iconmenublack;
        if (this.props.menuwhite) {
            iconmenu = iconmenuwhite;
        }

        return (
            <a className="menutoggler" onClick={this.toggleMenu.bind(this)} href="#"><img alt="Open menu" src={iconmenu}/><span className="menutoggler__label">Menu</span></a>
        );
    }
}

export default connect()(Menutoggler);



// WEBPACK FOOTER //
// ./src/components/menutoggler/menutoggler.js